
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import GeneralVehicleSelect from "@common/src/components/scope/vehicle-select/index.vue";
import FileUpload from "@common/src/components/scope/file-upload/index.vue";
import ExpandControl from "@/components/scope/expand-control.vue";
import dayjs from "dayjs";
import { priceRulesEl, mobileRulesEl, plateCodeRuleEl, mileageRulesEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import CustomerFlagSelect from "@common/src/components/scope/flag-select/index.vue";
import RepeatOrderDialog from "@common/src/components/scope/repeat-order-dialog/index.vue";
import { isCustomPlateCode } from "@common/src/utils/tools";

Component.registerHooks(["beforeRouteLeave"]);
const staff = namespace("staff");
const customer = namespace("customer");
const user = namespace("user");
const app = namespace("app");
const testingItem = namespace("testing-item");
const common_base = namespace("common_base");
const setting = namespace("setting");

@Component({
  components: { GeneralVehicleSelect, FileUpload, ExpandControl, CustomerFlag, CustomerFlagSelect, RepeatOrderDialog }
})
export default class TestingEdit extends Vue {
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @customer.Action getCustomerList;
  @customer.Action getCustomerDetail;
  @testingItem.Action getTestOrderDetail;
  @testingItem.Action completeTestOrder;
  @testingItem.Action getTestingTemplateList;
  @testingItem.Action getTestingTemplateDetail;
  @testingItem.Action saveTestOrder;
  @testingItem.Action getTempTestCode;
  @customer.Action saveCustomer;
  @common_base.Action getUploadToken;
  @user.State userData;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @app.State country;
  @setting.Getter isOpenDispatch;
  @testingItem.Action checkRepeatCreateCheckOrder;
  @user.State u8cStore;
  dayjs = dayjs;
  splitThousands = splitThousands;
  get breadData() {
    return [
      { name: t("test.service-management"), path: "/test/index" },
      { name: this.isAdd ? t("test.new-test") : t("test.edit-test") }
    ];
  }
  get isAdd() {
    return this.$route.name === "testAdd";
  }
  quitNext: any;
  shwoAddServiceModal: boolean = false; // 快捷添加服务modal框显示/隐藏
  shwoAddPartsModal: boolean = false; // 快捷添加零配件modal框显示/隐藏
  shwoQuitConfirm: boolean = false;
  beforeRouteLeave(to, from, next) {
    if (this.isAdd && to.name !== "testView" && this.watchOrderNum > 2) {
      this.shwoQuitConfirm = true;
      this.quitNext = next;
    } else {
      next();
    }
  }
  warningCount: number = 0;
  faultCount: number = 0;
  // 控制form disable状态
  formDisableStatus = {
    plateCode: false,
    customerModelCode: false,
    customerModelCode2: false,
    customerName: false,
    customerMobile: false
  };
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }

  counselor: string = "";
  advisorList: any[] = [{}];
  defaultVehicleList: any[] = [];
  emptyToLine = emptyToLine;
  showSelectCustomer: boolean = false;
  showAdditional: boolean = false;
  templateEnableAvm: string = "0";
  currentTemplateData: any = { checkItems: [] };
  orderFormData: any = {
    testOrderId: "",
    templateCode: "",
    advisorCode: "",
    technicianCode: "",
    customerCode: "",
    vehicleCode: "",
    customerMobile: "",
    customerModelCode: "",
    customerName: "",
    customerCurrentMileage: "",
    customerOilVolume: 0,
    assessPrice: "",
    storeRemark: "",
    leaveTime: dayjs().format("YYYYMMDD"),
    plateCode: ""
  };
  get customerFormRules() {
    return {
      plateCode: [{ required: true, validator: this.validatePlateCode, trigger: "blur" }],
      customerModelCode: [{ required: true, message: t("test.select-car-model"), trigger: "blur" }],
      customerMobile: [{ required: this.u8cStore ? true : false, validator: this.validateMobile, trigger: "blur" }],
      customerName: { required: this.u8cStore ? true : false, validator: this.validateCustomerName, trigger: "blur" },
      customerCurrentMileage: { required: this.u8cStore ? true : false, validator: this.checkMileage, trigger: "blur" }
    };
  }
  checkMileage(rule, value, callback) {
    mileageRulesEl(value, callback, this.u8cStore ? false : true);
  }
  validateMobile(rule, value, callback) {
    // 如果为空，客户信息没有手机号，做格式效验
    if (this.u8cStore || (value && !this.formDisableStatus.customerMobile)) {
      mobileRulesEl(value, callback);
    } else {
      callback();
    }
  }
  validateCustomerName(rule, value, callback) {
    if (this.u8cStore && !this.orderFormData.customerName) {
      callback(new Error(t("v210831.please-enter-customer")));
    } else {
      callback();
    }
  }
  get bigTtemList() {
    return this.currentTemplateData.checkItems || [];
  }

  get testOrderId() {
    return this.orderFormData.testOrderId || this.$route.params.id;
  }
  get showTestItemDetail() {
    if (this.$route.query.hideDetail) {
      return false;
    }
    if (this.isOpenDispatch) {
      if (this.isAdd) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
  get showAvmNotice() {
    return this.templateEnableAvm === "1";
  }
  created() {
    this.setPBPX(52);
    this.searchTemplateMethod();
    this.init();
  }

  async init() {
    if (this.isAdd) {
      this.getTempTestCode().then(data => {
        this.orderFormData.testOrderId = data.data.checkOrderNo;
      });
    }
    this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      if (this.isAdd) {
        this.orderFormData.advisorCode = this.userData.userCode;
        if (!this.isOpenDispatch) {
          this.orderFormData.technicianCode = this.userData.userCode;
        }
      }
    });
    if (!this.isAdd) {
      this.getTestOrderDetail({
        checkOrderNo: this.testOrderId
      }).then(data => {
        data.data.checkOrderDetails.forEach(item => {
          let itemCount = 0;
          this.$safeValue(item, "classSubItems", []).forEach(item2 => {
            item2.subItems.forEach(item3 => {
              item3.images = item3.images || [];
              item3.imagesCopy = (item3.images || []).slice();
              item3.selectValue = item3.selectValueNos ? item3.selectValueNos[0] : "";
              itemCount++;
              item3.selectValueNos = item3.selectValueNos || [];
              item3.excludeWarningLevels = item3.excludeWarningLevels || [];
            });
          });
          item.unfold = true; // 不折叠
          item.normalCount = 0; // 正常项数量
          item.seriousCount = 0; // 严重项数量
          item.warningCount = 0; // 预警项数量
          item.itemCount = itemCount; // 当前项目行数
          item.inputComplete = false; // 是否填写完成
        });
        this.customerLabelDescList = data.data.labelDescList;
        this.orderFormData = data.data;
        this.orderFormData.customerOilVolume = Number(data.data.customerOilVolume);
        this.defaultVehicleList = [
          {
            lastValue: data.data.customerModelCode,
            name: data.data.modelDesc
          }
        ];

        this.currentTemplateData.checkItems = data.data.checkOrderDetails;
        this.currentTemplateData.checkItems.forEach((item, index) => {
          this.checkBigItemComplete(index);
        });
        this.loadTemplateAvmFlag(data.data.templateCode);
        this.formDisableStatus.plateCode = true;
        this.formDisableStatus.customerModelCode = true;
        this.formDisableStatus.customerName = !!data.data.customerName;
        this.formDisableStatus.customerMobile = !!data.data.customerMobile;
      });
    } else {
      let customerCode = this.$route.query.customerCode;
      let vehicleCode = this.$route.query.vehicleCode;
      if (customerCode) {
        this.setCustomerData(vehicleCode, customerCode);
      }
    }
  }
  currentServiceRow: number = 0;
  validatePlateCode(rule, value, callback) {
    if (value && isCustomPlateCode(value)) {
      callback();
    } else {
      plateCodeRuleEl(value, callback, this.country);
    }
  }
  // 确认退出
  confirmQuit() {
    this.quitNext();
  }
  testTemplateList: any = [];
  switchLoading: boolean = false;
  loadTemplateAvmFlag(checkTemplateCode) {
    if (!checkTemplateCode) {
      this.templateEnableAvm = "0";
      return;
    }
    this.getTestingTemplateDetail({ checkTemplateCode }).then(data => {
      this.templateEnableAvm = this.$safeValue(data, "data.enableAvm", "0");
    });
  }
  handleSelectedTemplate(val) {
    this.switchLoading = true;
    this.getTestingTemplateDetail({ checkTemplateCode: val }).then(data => {
      this.templateEnableAvm = this.$safeValue(data, "data.enableAvm", "0");
      data.data.checkItems.forEach((item, bigItemIndex) => {
        let itemCount = 0;
        this.$safeValue(item, "classSubItems", []).forEach(item2 => {
          item2.subItems.forEach(item3 => {
            item3.selectValueNos = []; // 存服务端
            item3.excludeWarningLevels = []; // 存服务端
            item3.selectWarningLevel = ""; // 存服务端
            item3.images = []; // 存服务端
            item3.imagesCopy = [];
            if (item3.defaultValue) {
              item3.selectValue = item3.defaultValue;
              item3.selectValueNos = [item3.defaultValue];
              setTimeout(() => {
                this.handleValueInputEnd(item3, bigItemIndex);
              });
            }
            itemCount++; // 前端用
          });
        });
        item.unfold = true; // 不折叠 前端用
        item.normalCount = 0; // 正常项数量 前端用
        item.seriousCount = 0; // 严重项数量 前端用
        item.warningCount = 0; // 预警项数量 前端用
        item.itemCount = itemCount; // 当前项目行数 前端用
        item.inputComplete = false; // 是否填写完成 前端用
      });
      this.currentTemplateData = data.data;
      this.setDefaultSeleted(data.data);
      this.switchLoading = false;
    });
  }
  setDefaultSeleted(templateData) {
    const bigItemList = templateData.checkItems;
    bigItemList.forEach((bigItem, index1) => {
      bigItem.classSubItems.forEach(classItem => {
        classItem.subItems.forEach(subItem => {
          subItem.valueOptions.forEach(valueItem => {
            if (subItem.valueType === "2" && valueItem.warningLevel === "3") {
              // 设置正常默认值
              this.handleSelectOption(subItem, valueItem, index1);
            }
          });
        });
      });
    });
  }
  checkBigItemComplete(index) {
    let bigItemData = this.currentTemplateData.checkItems[index];
    let normalNum = 0;
    let seriousNum = 0;
    let warningNum = 0;
    let inputNum = 0;
    bigItemData.classSubItems.forEach(item => {
      item.subItems.forEach(item2 => {
        if (item2.valueType === "1") {
          // 检测项输入值类型
          if (item2.selectValue) {
            // 输入框有值
            inputNum += 1;
            if (!item2.selectWarningLevel) {
              // 没有匹配到valueOptions 就算严重
              seriousNum++;
            } else {
              let result = item2.valueOptions.find(valueOp => item2.selectWarningLevel === valueOp.warningLevel);
              if (result) {
                if (result.warningLevel === "1") {
                  seriousNum++;
                } else if (result.warningLevel === "2") {
                  warningNum++;
                } else {
                  normalNum++;
                }
              }
            }
          }
        } else {
          item2.selectValueNos.length && (inputNum += 1);
          item2.selectValueNos.forEach(item3 => {
            let result = item2.valueOptions.find(item4 => item4.valueNo === item3);
            if (result) {
              if (result.warningLevel === "1") {
                seriousNum++;
              } else if (result.warningLevel === "2") {
                warningNum++;
              } else {
                normalNum++;
              }
            }
          });
        }
      });
    });

    if (inputNum >= bigItemData.itemCount) {
      bigItemData.inputComplete = true;
      bigItemData.normalCount = normalNum;
      bigItemData.seriousCount = seriousNum;
      bigItemData.warningCount = warningNum;
    } else {
      bigItemData.normalCount = normalNum;
      bigItemData.seriousCount = seriousNum;
      bigItemData.warningCount = warningNum;
      bigItemData.inputComplete = false;
    }
  }
  searchTemplateMethod() {
    this.getTestingTemplateList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.testTemplateList = data.data.list;
    });
  }
  submitType: string = "";
  submitForm(type) {
    this.submitType = type;
    if (!this.orderFormData.customerCode) {
      this.$message.error(t("test.search-select-customer"));
      return;
    }
    if (this.u8cStore) {
      if (this.isAdd) {
        if (!this.seletedVehiCleData.vinCode) {
          this.seletedCustomer = "";
          return this.$message.error(t("v216_6.vin-code-tips"));
        }
      } else {
        if (!this.orderFormData.vinCode) {
          return this.$message.error(t("v216_6.vin-code-tips"));
        }
      }
    }
    (this.$refs.customerForm as any).validate(async valid => {
      if (this.isAdd) {
        if (valid && this.checkAddData()) {
          this.checkLastOrderData = await this.beforeSubmitCheck();
          if (!this.checkLastOrderData) {
            this.submitSaveTestOrder();
          }
        }
      } else {
        if (valid && this.checkEditData()) {
          this.submitSaveTestOrder();
        }
      }
    });
  }
  handleComplete() {
    let hasEmpty = false;
    this.currentTemplateData.checkItems.forEach((item1, bigIndex) => {
      item1.classSubItems.forEach(item2 => {
        item2.subItems.forEach((item3, index) => {
          if (item3.selectValueNos.length === 0) {
            hasEmpty = true;
            console.log(bigIndex, index);
            // this.scrollIntoView(
            //   document.querySelector(".page-test-order-add "),
            //   document.querySelector(`#mark${bigIndex}${index}`)
            // );
            return;
          }
        });
      });
    });
    if (hasEmpty) {
      this.$message.error(t("test.incomplete-test"));
      return false;
    }
    this.btnStartLoading();
    this.completeTestOrder({
      checkOrderNo: this.testOrderId
    })
      .then(() => {
        this.$message.success(t("test.have-been-completed"));
        this.$router.push(`/test/view/${this.testOrderId}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  customerLabelDescList: any = [];
  // 1:新建 2：编辑
  async submitSaveTestOrder() {
    let saveCustomerData = {
      vehicle: {
        plateCode: this.orderFormData.plateCode,
        modelCode: this.orderFormData.customerModelCode,
        vehicleCode: this.orderFormData.vehicleCode,
        labelDescList: this.customerLabelDescList
      },
      customerCode: this.orderFormData.customerCode,
      customerName: this.orderFormData.customerName,
      mobile: this.orderFormData.customerMobile
    };

    this.btnStartLoading();
    let savaHasError = false;
    await this.saveCustomer(saveCustomerData).then(
      () => {
        //
      },
      () => {
        this.btnStopLoading();
        savaHasError = true;
      }
    );

    if (savaHasError) return false;
    let params = {
      advisorCode: this.orderFormData.advisorCode,
      assessPrice: this.orderFormData.assessPrice,
      customerCode: this.orderFormData.customerCode,
      vehicleCode: this.orderFormData.vehicleCode,
      customerCurrentMileage: this.orderFormData.customerCurrentMileage,
      customerMobile: this.orderFormData.customerMobile,
      customerOilVolume: this.orderFormData.customerOilVolume,
      plateCode: this.orderFormData.plateCode,
      storeRemark: this.orderFormData.storeRemark,
      technicianCode: this.orderFormData.technicianCode,
      templateCode: this.orderFormData.templateCode,
      checkOrderDetails: this.currentTemplateData.checkItems.map(item => {
        return item;
      }),
      checkOrderNo: this.testOrderId
    };

    this.btnStartLoading();
    this.saveTestOrder(params)
      .then(data => {
        if (this.isAdd) {
          this.orderFormData.testOrderId = data.data.checkOrderNo;
        }
        if (this.submitType === "save") {
          this.$message.success(t("base.save-success"));
          this.$router.push(`/test/view/${this.testOrderId}`);
        } else {
          this.handleComplete();
        }
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  checkAddData(): boolean {
    if (!this.orderFormData.templateCode) {
      this.$message.error(t("test.select-test-template"));
      return false;
    }
    if (!this.checkBottomExtraData()) {
      return false;
    }
    return true;
  }
  checkEditData(): boolean {
    if (!this.checkBottomExtraData()) {
      return false;
    }
    return true;
  }
  checkBottomExtraData(): boolean {
    if (this.orderFormData.storeRemark && this.orderFormData.storeRemark.length > 50) {
      this.$message.error(t("v213.store-remarks-can-be-up-to-characters-long"));
      return false;
    }
    if (!this.orderFormData.assessPrice) {
      return true;
    }
    let hasError = false;
    priceRulesEl(this.orderFormData.assessPrice, error => {
      if (error) {
        hasError = true;
        this.$message.error(error.message);
      }
    });
    return !hasError;
  }
  linkCreateCustomer() {
    let { href } = this.$router.resolve({
      path: `/setting/customer-add`
    });
    window.open(href, "_blank");
  }

  seletedCustomer: string = "";
  customerList: any[] = [];
  handleShowSelCustomer() {
    this.showSelectCustomer = true;
    this.$nextTick(() => {
      (this.$refs["select-customer"] as any).focus();
    });
  }
  handleSearchCustomer(val) {
    if (val) {
      this.getCustomerList({
        pageSize: 20,
        pageNum: 1,
        searchKey: val
      }).then(data => {
        this.customerList = this.$safeValue(data, "data.list", []).map(item => {
          item.label = `${item.plateCode}${item.customerName ? "/" + item.customerName : ""} ${
            item.mobile ? "/" + item.mobile : ""
          }`;
          return item;
        });
      });
    } else {
      this.customerList = [];
    }
  }
  handleChooseCustomer(val) {
    const customer = this.customerList.find(item => {
      return val === item.vehicleCode;
    });
    this.orderFormData.customerCode = this.$safeValue(customer, "customerCode", "");
    this.setCustomerData(val, customer?.customerCode);
  }
  seletedVehiCleData: any = {};
  setCustomerData(vehicleCode, customerCode) {
    this.getCustomerDetail({
      customerCode: customerCode,
      vehicleCode: vehicleCode
    }).then(data => {
      const customerData = data.data;
      let vehicleList = data.data.vehicleList || [];
      let vehicleData = data.data.vehicleList.find(item => {
        return data.data.selectedVehicleCode === item.vehicleCode;
      });
      if (!vehicleData) {
        // 没传车辆code取第一辆
        vehicleData = vehicleList[0] || {};
        vehicleCode = vehicleData.vehicleCode;
      }
      this.seletedVehiCleData = vehicleData;
      this.orderFormData.customerCode = customerCode;
      this.orderFormData.customerName = customerData.customerName;
      this.orderFormData.customerMobile = customerData.mobile;
      this.formDisableStatus.customerName = !!customerData.customerName;
      this.formDisableStatus.customerMobile = !!customerData.mobile;

      if (vehicleData) {
        this.orderFormData.vehicleCode = vehicleData?.vehicleCode || "";
        this.orderFormData.plateCode = vehicleData?.plateCode || "";
        this.orderFormData.customerCurrentMileage = vehicleData?.lastMaintenanceMileage || "";
        this.defaultVehicleList = this.vehicleDataFormat([vehicleData]);
        this.formDisableStatus.plateCode = !!vehicleData.plateCode;
        this.formDisableStatus.customerModelCode = !!vehicleData;
        this.formDisableStatus.customerModelCode2 = !!this.defaultVehicleList[0].lastValue; //获取到车型为空时，当前客户信息-车型 可编辑&&不禁用
        this.customerLabelDescList = vehicleData.labelDescList; // 客户标签回显
        if (vehicleData.lastCheckOrderNo) {
          this.lastCheckTime = vehicleData.lastCheckTime;
          this.lastCheckOrderNo = vehicleData.lastCheckOrderNo;
        } else {
          this.lastCheckTime = "";
          this.lastCheckOrderNo = "";
        }
      } else {
        this.lastCheckTime = "";
        this.lastCheckOrderNo = "";
      }
      // 获取到车辆信息重新验证格式
      this.$nextTick(() => {
        (this.$refs["customerForm"] as any).validateField("customerModelCode");
      });
    });
  }
  vehicleDataFormat(data) {
    return data.map(item => ({
      lastValue: item.modelCode,
      name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
      valueGroup: [item.brandCode, item.seriesName, item.modelCode]
    }));
  }
  handleSelectOption(row, valueItem, index) {
    if (valueItem.warningLevel === "3") {
      for (let index = 0; index < row.excludeWarningLevels.length; index++) {
        const item = row.excludeWarningLevels[index];
        if (item === "1" || item === "2") {
          row.selectValueNos.splice(index, 1);
          row.excludeWarningLevels.splice(index, 1);
          index--;
        }
      }
    } else {
      for (let index = 0; index < row.excludeWarningLevels.length; index++) {
        const item = row.excludeWarningLevels[index];
        if (item === "3") {
          row.selectValueNos.splice(index, 1);
          row.excludeWarningLevels.splice(index, 1);
          index--;
        }
      }
    }
    let findIndex = row.selectValueNos.indexOf(valueItem.valueNo);
    if (findIndex > -1) {
      row.selectValueNos.splice(findIndex, 1);
      row.excludeWarningLevels.splice(findIndex, 1);
    } else {
      row.selectValueNos.push(valueItem.valueNo);
      row.excludeWarningLevels.push(valueItem.warningLevel);
    }
    this.checkBigItemComplete(index);
  }
  handleSetValues(row) {
    if (row.selectValue) {
      row.selectValueNos = [row.selectValue];
    } else {
      row.selectValueNos = [];
    }
  }
  handleValueInputEnd(row, bigItemIndex) {
    if (!row.selectValue) {
      // 空值不对比
      row.selectValue = "";
      row.selectWarningLevel = "";
      return;
    }
    let valueList = row.valueOptions;
    // this.checkBigItemComplete(index);
    for (let index = 0; index < valueList.length; index++) {
      const element = valueList[index];
      if (element.minValueOperator === "gt" && element.maxValueOperator === "lt") {
        if (Number(row.selectValue) > Number(element.minValue) && Number(row.selectValue) < Number(element.maxValue)) {
          // 小于 大于
          row.selectWarningLevel = valueList[index].warningLevel;
          row.warningText = valueList[index].warningLevelDesc;
          this.checkBigItemComplete(bigItemIndex);
          return;
        }
      }
      if (element.minValueOperator === "gt" && element.maxValueOperator === "le") {
        if (Number(row.selectValue) > Number(element.minValue) && Number(row.selectValue) <= Number(element.maxValue)) {
          // 小于等于 大于
          row.selectWarningLevel = valueList[index].warningLevel;
          row.warningText = valueList[index].warningLevelDesc;
          this.checkBigItemComplete(bigItemIndex);
          return;
        }
      }
      if (element.minValueOperator === "ge" && element.maxValueOperator === "lt") {
        if (Number(row.selectValue) >= Number(element.minValue) && Number(row.selectValue) < Number(element.maxValue)) {
          // 小于等于 大于
          row.selectWarningLevel = valueList[index].warningLevel;
          row.warningText = valueList[index].warningLevelDesc;
          this.checkBigItemComplete(bigItemIndex);
          return;
        }
      }
      if (element.minValueOperator === "ge" && element.maxValueOperator === "le") {
        if (
          Number(row.selectValue) >= Number(element.minValue) &&
          Number(row.selectValue) <= Number(element.maxValue)
        ) {
          // 小于等于 大于
          row.selectWarningLevel = valueList[index].warningLevel;
          row.warningText = valueList[index].warningLevelDesc;
          this.checkBigItemComplete(bigItemIndex);
          return;
        }
      }
    }
    row.selectValue = "";
    row.selectValueNos = [];
    row.selectWarningLevel = "";
    this.$message.warning(t("test.value-entered-not-range"));
    // this.checkBigItemComplete(bigItemIndex);
  }
  handleOpoColse() {
    // 关闭去掉错误状态
    (this.$refs["customerForm"] as any).validateField("customerModelCode");
  }
  watchOrderNum = 0;
  @Watch("orderFormData", { deep: true })
  WatchOrderData() {
    this.watchOrderNum += 1;
  }

  scrollIntoView(container, selected) {
    if (!selected) {
      container.scrollTop = 0;
      return;
    }
    const offsetParents = [];
    let pointer = selected.offsetParent;
    while (pointer && container !== pointer && container.contains(pointer)) {
      offsetParents.push(pointer);
      pointer = pointer.offsetParent;
    }
    const top = selected.offsetTop + offsetParents.reduce((prev, curr) => prev + curr.offsetTop, 0);
    const bottom = top + selected.offsetHeight;
    const viewRectTop = container.scrollTop;
    const viewRectBottom = viewRectTop + container.clientHeight;

    if (top < viewRectTop) {
      container.scrollTop = top - 80;
    } else if (bottom > viewRectBottom) {
      container.scrollTop = bottom - container.clientHeight - 80;
    }
  }
  lastCheckTime = "";
  lastCheckOrderNo = "";
  checkLastOrderData: any = {};
  beforeSubmitCheck() {
    return this.checkRepeatCreateCheckOrder({
      mobile: this.orderFormData.customerMobile,
      plateCode: this.orderFormData.plateCode
    }).then(data => {
      return data.data;
    });
  }
  handleConfirmCreateOrder() {
    this.checkLastOrderData = {};
    this.submitSaveTestOrder();
  }
}
